export default "./dist/stdassets/images/icons/select-zoom.png";